export default "__VITE_ASSET__99619e96__"